import { createContext, useContext, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { directoryApi } from './api';

const DirectoryContext = createContext({ user: null, loading: true });
export const DirectoryProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let active = true;
    directoryApi.get('/auth/session').then(async r => {
      if (r.data.user) return r.data.user;
      if (r.data.refresh_available) return (await directoryApi.post('/auth/refresh')).data.user;
      return null;
    }).then(value => { if (active) setUser(value); }).catch(() => { if (active) setUser(null); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);
  const logout = async () => { await directoryApi.post('/auth/logout'); setUser(null); };
  return <DirectoryContext.Provider value={{ user, setUser, loading, logout }}>{children}</DirectoryContext.Provider>;
};
export const useDirectoryUser = () => useContext(DirectoryContext);
export const DirectoryGate = ({ children }) => {
  const { user, loading } = useDirectoryUser();
  const location = useLocation();
  if (loading) return <p data-testid="directory-session-loading" className="py-12 text-sm">Checking your secure session…</p>;
  if (!user) return <Navigate replace to={`/directory/sign-in?return=${encodeURIComponent(location.pathname + location.search)}`} />;
  return children;
};